var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolution4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 262 262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ebf2fc;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #1930ab;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.08,100.98c0,68.4-63.4,152.3-137.24,152.3S4.92,202.51,4.92,134.12,46,5.72,119.84,5.72s137.24,26.86,137.24,95.25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.9,118h-34.19v-63.29c0-1.25-1.02-2.27-2.27-2.27h-109.01c-1.25,0-2.27,1.01-2.27,2.27v128.34c0,11.3,9.19,20.5,20.5,20.5h109.01c11.3,0,20.49-9.19,20.49-20.5v-62.79c0-1.25-1.02-2.27-2.27-2.27Zm-127.24,81.02c-8.8,0-15.96-7.16-15.96-15.96V56.98h104.48v126.08c0,6.45,3,12.21,7.67,15.96h-96.18Zm124.97-15.96c0,8.8-7.16,15.96-15.96,15.96s-15.96-7.16-15.96-15.96v-60.52h31.92s0,60.52,0,60.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.8,98.6h29.46c1.25,0,2.27-1.01,2.27-2.27v-29.46c0-1.25-1.01-2.27-2.27-2.27h-29.46c-1.25,0-2.27,1.01-2.27,2.27v29.46c0,1.25,1.01,2.27,2.27,2.27Zm2.27-29.46h24.93v24.93h-24.93v-24.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.45,64.6h-32.41c-1.25,0-2.27,1.01-2.27,2.27s1.01,2.27,2.27,2.27h32.41c1.25,0,2.27-1.01,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.45,83.01h-32.41c-1.25,0-2.27,1.01-2.27,2.27s1.01,2.27,2.27,2.27h32.41c1.25,0,2.27-1.01,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.45,101.43h-32.41c-1.25,0-2.27,1.01-2.27,2.27s1.01,2.27,2.27,2.27h32.41c1.25,0,2.27-1.01,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.45,119.84h-82.49c-1.25,0-2.27,1.01-2.27,2.27s1.01,2.27,2.27,2.27h82.49c1.25,0,2.27-1.01,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.45,138.25h-82.49c-1.25,0-2.27,1.02-2.27,2.27s1.01,2.27,2.27,2.27h82.49c1.25,0,2.27-1.02,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.45,156.67h-82.49c-1.25,0-2.27,1.02-2.27,2.27s1.01,2.27,2.27,2.27h82.49c1.25,0,2.27-1.02,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m162.45,175.08h-82.49c-1.25,0-2.27,1.02-2.27,2.27s1.01,2.27,2.27,2.27h82.49c1.25,0,2.27-1.02,2.27-2.27s-1.02-2.27-2.27-2.27Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution4);
export default __webpack_public_path__ + "static/media/solution4.150f9eccf30cbfcd5fe27218e7b7407f.svg";
export { ForwardRef as ReactComponent };